import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterVehicleSearchValueObject} from './FilterVehicleSearchValueObject.js'

const WHOLE_MAKE_MODEL_ID = 0

export class FilterExcludedVehiclesSearchValueObject extends ValueObject {
  #excludedVehicles

  constructor({excludedVehicles}) {
    super()
    this.#excludedVehicles = excludedVehicles
  }

  static create({excludedVehicles = []} = {}) {
    return new FilterExcludedVehiclesSearchValueObject({
      excludedVehicles: excludedVehicles
        .filter(({makeId}) => Boolean(makeId))
        .map(({make, makeId, model, modelId}) =>
          FilterVehicleSearchValueObject.createFromGroupedModel({
            make,
            makeId,
            model: {id: model?.id ?? modelId ?? WHOLE_MAKE_MODEL_ID, name: model?.name}
          })
        )
    })
  }

  static createQueryParams({config, excludedVehicles = []}) {
    const {FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')
    const {makeId: makeIdKey, modelId: modelIdKey} = FILTER_QUERY_PARAMS[FILTER_NAMES.EXCLUDED_VEHICLES]
    const cleanedVehicles = FilterExcludedVehiclesSearchValueObject.create({excludedVehicles}).value

    return new FilterExcludedVehiclesSearchValueObject({
      excludedVehicles: {
        makes: QueryParamSharedValueObject.createForSingle({
          key: makeIdKey,
          value: cleanedVehicles.map(({makeId}) => makeId)
        }),
        models: QueryParamSharedValueObject.createForSingle({
          key: modelIdKey,
          value: cleanedVehicles.map(({model}) => model.id)
        })
      }
    })
  }

  get isEmpty() {
    return !this.#excludedVehicles.length
  }

  get queryParams() {
    return {
      ...(!this.#excludedVehicles.makes.isEmpty && {...this.#excludedVehicles.makes.queryParam}),
      ...(!this.#excludedVehicles.models.isEmpty && {...this.#excludedVehicles.models.queryParam})
    }
  }

  get value() {
    return this.#excludedVehicles.map(vehicle => vehicle.valueWithGroupedModel)
  }

  get valueToApi() {
    return this.value.map(({makeId, model}) => ({
      makeId: Number(makeId),
      ...(model.id && {modelId: Number(model.id)})
    }))
  }

  toJSON() {
    return {excludedVehicles: this.value}
  }
}
